import {
  ArchiveAddScreenFragment,
  ArchiveRemoveScreenFragment,
  MyArchiveFragment,
} from '@/graphql/custom-types';
import {
  ArchiveAddScreenDocument,
  ArchiveRemoveScreenDocument,
  GetMyArchiveScreenDocument,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getMyArchive = async (
  profile: ScreenProfile
): Promise<MyArchiveFragment> => {
  const response = await apolloClient.query({
    query: GetMyArchiveScreenDocument,
    variables: { profile },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.myArchiveScreen) {
    return response.data.myArchiveScreen;
  }

  throw new SentryGraphQLError('api.archive.getMyArchive', response);
};

const archiveAdd = async (
  profile: ScreenProfile,
  resourceId: string
): Promise<ArchiveAddScreenFragment> => {
  const response = await apolloClient.mutate({
    mutation: ArchiveAddScreenDocument,
    variables: { profile, resourceId },
    errorPolicy: 'all',
  });

  if (response.data?.archiveAddScreen) {
    return response.data.archiveAddScreen;
  }

  throw new SentryGraphQLError('api.archive.archiveAdd', response);
};

const archiveRemove = async (
  profile: ScreenProfile,
  resourceId: string
): Promise<ArchiveRemoveScreenFragment> => {
  const response = await apolloClient.mutate({
    mutation: ArchiveRemoveScreenDocument,
    variables: { profile, resourceId },
    errorPolicy: 'all',
  });

  if (response.data?.archiveRemoveScreen) {
    return response.data.archiveRemoveScreen;
  }

  throw new SentryGraphQLError('api.archive.archiveRemove', response);
};

export default {
  getMyArchive,
  archiveAdd,
  archiveRemove,
};
